import * as React from 'react';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../reducers';
import { setActiveItem, toggleEditPanel } from '../../../containers/Editor/actions';
import EditPanel from '../../../containers/Editor/EditPanel';
import ThemesPanel from '../../../containers/Editor/EditPanel/ThemesPanel';
import { getBorderWidth } from '../../../containers/Editor/utils/helpers';
import { EditableType, IGNORE_PAGE_CLICK_CLASSNAME } from '../../../containers/Editor/constants';
import { StyledThemedItemEditor, Border } from './styles';

interface ThemedItemEditorProps {
	page: number;
	id: string;
	isActive: boolean;
	pageScale: number;
	isEditPanelDisplayed: boolean;
	dispatch: Dispatch<StoreState>;
}

const ThemedItemEditor = ({
	page,
	id,
	isActive,
	pageScale,
	isEditPanelDisplayed,
	dispatch,
}: ThemedItemEditorProps) => {
	const handleClick = () => {
		if (!isActive) {
			dispatch(setActiveItem(id, page, null));

			if (!isEditPanelDisplayed) {
				dispatch(toggleEditPanel());
			}
		}
	};

	const renderEditPanel = () => (
		isActive && isEditPanelDisplayed && (
			<EditPanel
				defaultType={EditableType.themes}
				panels={{
					[EditableType.themes]: <ThemesPanel />,
				}}
			/>
		)
	);

	return (
		<>
			<StyledThemedItemEditor
				className={IGNORE_PAGE_CLICK_CLASSNAME}
				onClick={handleClick}
				onTouchEnd={handleClick}
			>
				{isActive &&
					<Border borderWidth={getBorderWidth(pageScale)} />
				}
			</StyledThemedItemEditor>
			{renderEditPanel()}
		</>
	);
};

export default ThemedItemEditor;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ThemedItemEditor/index.tsx